import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatBubble from "./components/ChatBubble";
import WelcomeModal from "./components/WelcomeModal";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import CreateRequest from "./pages/CreateRequest";
import LearningFlow from "./pages/LearningFlow";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import TrackOrder from "./pages/TrackOrder";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/FAQ";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import AdminDashboard from "./pages/AdminDashboard";
import { useVisitorTracking } from "./hooks/useVisitorTracking";

function TrackingWrapper({ children }) {
  const { trackPageView } = useVisitorTracking();
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location.pathname, trackPageView]);

  return children;
}

function PublicLayout() {
  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      <Navbar />
      <WelcomeModal />
      <ChatBubble />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/create-request" element={<CreateRequest />} />
          <Route path="/learn" element={<LearningFlow />} />
          <Route path="/payment/:requestId" element={<Payment />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/track" element={<TrackOrder />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <TrackingWrapper>
          <Routes>
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<PublicLayout />} />
          </Routes>
        </TrackingWrapper>
      </Router>
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: "#1f2937", color: "#fff", borderRadius: "12px" },
        }}
      />
    </AuthProvider>
  );
}

export default App;
